/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DeactivateElectronMapperItem } from './DeactivateElectronMapperItem';
import {
    DeactivateElectronMapperItemFromJSON,
    DeactivateElectronMapperItemFromJSONTyped,
    DeactivateElectronMapperItemToJSON,
    DeactivateElectronMapperItemToJSONTyped,
} from './DeactivateElectronMapperItem';

/**
 * 
 * @export
 * @interface DeactivateElectronDataMappersResponse
 */
export interface DeactivateElectronDataMappersResponse {
    /**
     * Whether this was a dry run
     * @type {boolean}
     * @memberof DeactivateElectronDataMappersResponse
     */
    dryRun: boolean;
    /**
     * Number of data mappers deactivated (or would be deactivated)
     * @type {number}
     * @memberof DeactivateElectronDataMappersResponse
     */
    deactivatedCount: number;
    /**
     * List of mappers that were/would be deactivated (dry run only)
     * @type {Array<DeactivateElectronMapperItem>}
     * @memberof DeactivateElectronDataMappersResponse
     */
    mappers?: Array<DeactivateElectronMapperItem>;
}

/**
 * Check if a given object implements the DeactivateElectronDataMappersResponse interface.
 */
export function instanceOfDeactivateElectronDataMappersResponse(value: object): value is DeactivateElectronDataMappersResponse {
    if (!('dryRun' in value) || value['dryRun'] === undefined) return false;
    if (!('deactivatedCount' in value) || value['deactivatedCount'] === undefined) return false;
    return true;
}

export function DeactivateElectronDataMappersResponseFromJSON(json: any): DeactivateElectronDataMappersResponse {
    return DeactivateElectronDataMappersResponseFromJSONTyped(json, false);
}

export function DeactivateElectronDataMappersResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeactivateElectronDataMappersResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'dryRun': json['dryRun'],
        'deactivatedCount': json['deactivatedCount'],
        'mappers': json['mappers'] == null ? undefined : ((json['mappers'] as Array<any>).map(DeactivateElectronMapperItemFromJSON)),
    };
}

export function DeactivateElectronDataMappersResponseToJSON(json: any): DeactivateElectronDataMappersResponse {
    return DeactivateElectronDataMappersResponseToJSONTyped(json, false);
}

export function DeactivateElectronDataMappersResponseToJSONTyped(value?: DeactivateElectronDataMappersResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'dryRun': value['dryRun'],
        'deactivatedCount': value['deactivatedCount'],
        'mappers': value['mappers'] == null ? undefined : ((value['mappers'] as Array<any>).map(DeactivateElectronMapperItemToJSON)),
    };
}

